"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// forked from https://github.com/quasarframework/quasar/blob/master/app/lib/app-extension/Extension.js
var fast_glob_1 = __importDefault(require("fast-glob"));
var fs_extra_1 = __importDefault(require("fs-extra"));
var isbinaryfile_1 = require("isbinaryfile");
var lodash_1 = require("lodash");
var path_1 = require("path");
var copyTemplates = function (_a) {
    var source = _a.source, target = _a.target, scope = _a.scope;
    var files = fast_glob_1.default.sync(['**/*'], {
        cwd: source
    });
    for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
        var rawPath = files_1[_i];
        var targetRelativePath = rawPath
            .split('/')
            .map(function (name) {
            // dotfiles are ignored when published to npm, therefore in templates
            // we need to use underscore instead (e.g. "_gitignore")
            if (name.startsWith('_') && name.charAt(1) !== '_') {
                return "." + name.slice(1);
            }
            if (name.startsWith('_') && name.charAt(1) === '_') {
                return "" + name.slice(1);
            }
            return name;
        })
            .join('/');
        var targetPath = path_1.join(target, targetRelativePath);
        var sourcePath = path_1.resolve(source, rawPath);
        fs_extra_1.default.ensureFileSync(targetPath);
        if (isbinaryfile_1.isBinaryFileSync(sourcePath)) {
            fs_extra_1.default.copyFileSync(sourcePath, targetPath);
        }
        else {
            // eslint-disable-next-line security/detect-non-literal-fs-filename
            var rawContent = fs_extra_1.default.readFileSync(sourcePath, 'utf-8');
            var compiled = lodash_1.template(rawContent, {
                interpolate: /<%=([\s\S]+?)%>/g
            });
            // eslint-disable-next-line security/detect-non-literal-fs-filename
            fs_extra_1.default.writeFileSync(targetPath, compiled(scope), 'utf-8');
        }
    }
};
exports.default = copyTemplates;
